import { UrlHelpers } from "@/shared/services/UrlHelpers"

export function loadImageFromURL(src): Promise<HTMLImageElement | null> {
  return new Promise((resolve, reject) => {
    const image = new Image()
    // image.src = src.replace('https://d3m8xwj68a8dxg.cloudfront.net','/cloudfront')
    // image.src = src.replace('https://media.bazaart.com','/media')
    image.onload = () => {
      resolve(image)
    }
    image.onerror = (err) => {
      if (err.code === "ERR_CANCELED") {
        resolve(null);
      } else {
        reject(err);
      }
    }
    image.crossOrigin = 'Anonymous'
    image.src = UrlHelpers.prepareUrl(src)
  })
}

export function dataURLtoBlob(dataURL) {
  let array, binary, i, len
  binary = atob(dataURL.split(',')[1])
  array = []
  i = 0
  len = binary.length
  while (i < len) {
    array.push(binary.charCodeAt(i))
    i++
  }
  return new Blob([new Uint8Array(array)], {
    type: 'image/png',
  })
}
